import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {ArticleService} from '../services/article.service';
import {Article} from '../classes/article.class';
import {CodaltComponent} from '../codalt.component';
import {IPageInfo, VirtualScrollerModule} from '@iharbeck/ngx-virtual-scroller';
import {ActivatedRoute, RouterLink, RouterOutlet} from '@angular/router';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {CodaltImageComponent} from "../codalt-image/codalt-image.component";
import {DatePipe} from "@angular/common";
import {MatFabButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        VirtualScrollerModule,
        CodaltImageComponent,
        DatePipe,
        MatFabButton,
        MatIcon,
        RouterOutlet
    ]
})
export class ArticlesComponent extends CodaltComponent implements OnInit, OnDestroy {

    readonly childActive = signal<boolean>(false);

    readonly articles = signal<Article[]>([]);
    readonly loading = signal<boolean>(true);
    readonly future = signal<boolean>(false);
    private limit = 9;
    private skip = 0;
    private allLoaded = false;

    constructor(
        private articleService: ArticleService,
        private dialog: ConfirmDialogService,
        private route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit(): void {
        this.skip = 0;
        this.getArticles();
    }

    childClosed(event) {
        if (event?.reserve) {
            this.skip = 0;
            this.getArticles();
        } else if (event?.form) {
            const article = this.articles().find(a => a.id === event?.article?.id);
            if (article !== undefined) {
                Object.assign(article, event?.article);
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    scroll(article: IPageInfo) {
        if (!this.loading() && !this.allLoaded) {
            if (article.endIndex > (this.articles().length) - 3) {
                this.skip += this.limit;
                this.getArticles();
            }
        }
    }

    private getArticles() {
        this.loading.set(true);
        this.future.set(typeof this.route.snapshot.url[0] !== 'undefined' && this.route.snapshot.url[0].path === 'toekomst');
        this.articleService.getList(this.limit, this.skip, this.future()).subscribe(articles => {
            if (this.skip === 0) {
                this.articles.set([]);
            }
            this.allLoaded = articles.data.length < this.limit;
            this.articles.update(() => [...articles.data]);
            this.loading.set(false);
        }, () => {
            this.loading.set(false);
        });
    }
}
